import { useState, useMemo } from "react";

const useSortedContests = (
  contests,
  initialSortKey = "deadline",
  initialSortDirection = "ascending"
) => {
  const [sortConfig, setSortConfig] = useState({
    key: initialSortKey,
    direction: initialSortDirection,
  });

  const sortedContests = useMemo(() => {
    return [...contests].sort((a, b) => {
      if (sortConfig.key === "name") {
        return sortConfig.direction === "ascending"
          ? a.tournamentName.localeCompare(b.tournamentName)
          : b.tournamentName.localeCompare(a.tournamentName);
      }
      if (sortConfig.key === "fee") {
        return sortConfig.direction === "ascending"
          ? a.entryFee - b.entryFee
          : b.entryFee - a.entryFee;
      }
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  }, [contests, sortConfig]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  return { sortedContests, requestSort, sortConfig };
};

export default useSortedContests;
